var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.56 24.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#010101;stroke-miterlimit:11.34;stroke-width:0.85px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path821-0",
    className: "cls-1",
    d: "M2.55,3c6.2,0,11.09,23.9,17.3,23.9S30.9,3,37.32,3s10.84,23.9,17.08,23.9S65.46,3,71.88,3",
    transform: "translate(-2.55 -2.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path821-0-2",
    className: "cls-1",
    d: "M71.71,3c6.2,0,11.05,23.9,17.47,23.9S100.23,3,106.44,3s10.88,23.9,17.08,23.9S134.62,3,141,3",
    transform: "translate(-2.55 -2.57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path821-0-3",
    className: "cls-1",
    d: "M140.82,3c6.2,0,10.92,23.9,17.26,23.9S169.17,3,175.55,3s10.88,23.9,17.08,23.9S203.69,3,210.11,3",
    transform: "translate(-2.55 -2.57)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardin);
export default __webpack_public_path__ + "static/media/Gardin.545a83f7afc534e035f70cf6bd802c25.svg";
export { ForwardRef as ReactComponent };